import { reactive } from 'vue';

export const state = reactive({
  breadcrumbs: [],
  data: [],
  names: [],
  label: '',
});
